module.exports = __webpack_public_path__ + "static/media/mesonry-lg-2.8287f1d4.jpg";